themeBase.requestIdleCallback(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    if (!customElements.get('media-zoom')) {
      class MediaZoom extends HTMLElement {
        constructor() {
          super();

          if (this.closest('quick-add-modal')) return;

          this.isFirst = true;
          this.isActive = false;
          this.animationFrame = null;
          this.pendingEvent = null;
          this.parent = this.closest('.media-zoom-parent');
          this.image = this.querySelector('.media-zoom__zoom-image');
          this.img = this.image?.querySelector('img');
          this.offsetCoef = 0.75;
          this.scaleCoef = Number.parseFloat(this.dataset.scaleCoef);

          if (!this.parent || !this.image || !this.img || !Number.isFinite(this.scaleCoef) || this.scaleCoef <= 1) return;

          this.onMouseenter = this.onMouseenter.bind(this);
          this.onMouseleave = this.onMouseleave.bind(this);
          this.onMousemove = this.onMousemove.bind(this);
          this.onScroll = this.onScroll.bind(this);

          this.parent.addEventListener('mouseenter', this.onMouseenter, { passive: true });
          this.parent.addEventListener('mouseleave', this.onMouseleave, { passive: true });
          this.parent.addEventListener('mousemove', this.onMousemove, { passive: true });
          window.addEventListener('throttle60fpsScroll', this.onScroll, { passive: true });
        }

        disconnectedCallback() {
          this.cancelPendingFrame();
          this.parent?.removeEventListener('mouseenter', this.onMouseenter);
          this.parent?.removeEventListener('mouseleave', this.onMouseleave);
          this.parent?.removeEventListener('mousemove', this.onMousemove);
          window.removeEventListener('throttle60fpsScroll', this.onScroll);
        }

        onMouseenter(event) {
          this.isFirst = false;
          this.isActive = true;
          this.updateSizes();

          if (!this.width || !this.height) {
            this.isActive = false;
            return;
          }

          this.parent.classList.add('media-zoom-parent--zooming');
          this.classList.add('media-zoom--active');
          this.schedulePositionUpdate(event);
        }

        onMouseleave() {
          this.isActive = false;
          this.cancelPendingFrame();
          this.parent.classList.remove('media-zoom-parent--zooming');
          this.classList.remove('media-zoom--active');
          this.image.style.removeProperty('transform');
        }

        onMousemove(event) {
          if (this.isFirst) {
            this.onMouseenter(event);
            return;
          }

          if (this.isActive) this.schedulePositionUpdate(event);
        }

        onScroll() {
          if (this.isActive) this.schedulePositionUpdate();
        }

        schedulePositionUpdate(event) {
          if (event) {
            this.pendingEvent = {
              clientY: event.clientY,
              clientX: getLogicalClientX(event)
            };
          }

          if (this.animationFrame !== null) return;

          this.animationFrame = requestAnimationFrame(() => {
            this.animationFrame = null;
            if (!this.isActive || !this.isConnected) return;
            this.updatePosition(this.pendingEvent);
            this.pendingEvent = null;
          });
        }

        cancelPendingFrame() {
          if (this.animationFrame !== null) {
            cancelAnimationFrame(this.animationFrame);
            this.animationFrame = null;
          }
          this.pendingEvent = null;
        }

        updateSizes() {
          const bounds = this.getBoundingClientRect();
          this.width = bounds.width;
          this.height = bounds.height;
        }

        updatePosition(event) {
          let clientY = event?.clientY;
          let clientX = event?.clientX;

          if (!Number.isFinite(clientY) || !Number.isFinite(clientX)) {
            clientY = this.clientY;
            clientX = this.clientX;
          }

          if (!Number.isFinite(clientY) || !Number.isFinite(clientX) || !this.width || !this.height) return;

          const imageBounds = themeBounds.get(this.parent);
          if (!imageBounds || !Number.isFinite(imageBounds.top) || !Number.isFinite(imageBounds.left)) return;

          const rangeHeight = this.height * this.offsetCoef;
          const rangeWidth = this.width * this.offsetCoef;
          if (!rangeHeight || !rangeWidth) return;

          const offsetHeight = (this.height - rangeHeight) / 2;
          const offsetWidth = (this.width - rangeWidth) / 2;
          const cursorTop = clientY - imageBounds.top;
          const cursorLeft = clientX - imageBounds.left;
          let top = 0;
          let left = 0;
          this.clientY = clientY;
          this.clientX = clientX;

          if (cursorTop >= this.height - offsetHeight) {
            top = Math.floor((this.height - offsetHeight * 2) * (this.height * this.scaleCoef - this.height) / rangeHeight);
          } else if (cursorTop > offsetHeight) {
            top = Math.floor((cursorTop - offsetHeight) * (this.height * this.scaleCoef - this.height) / rangeHeight);
          }

          if (cursorLeft >= this.width - offsetWidth) {
            left = Math.floor((this.width - offsetWidth * 2) * (this.width * this.scaleCoef - this.width) / rangeWidth);
          } else if (cursorLeft > offsetWidth) {
            left = Math.floor((cursorLeft - offsetWidth) * (this.width * this.scaleCoef - this.width) / rangeWidth);
          }

          if (!Number.isFinite(top) || !Number.isFinite(left)) return;
          this.image.style.transform = `translate3d(${flipLogicalValue(-left)}px, ${-top}px, 0)`;
        }
      }

      customElements.define('media-zoom', MediaZoom);
    }
  });
});
